import React, { useEffect, useMemo, useState } from "react";
import Grid from "./Grid";
import RhfInput from "./rhfFields/RhfInput";
import RhfSelect from "./rhfFields/RhfSelect";
import USDATA from "@/utils/US_Data.json";
import { useFormContext, useWatch } from "react-hook-form";
import axios from "axios";

type Props = {
  cityName: string;
  stateName: string;
  zipcodeName: string;
  componentBefore?: React.ReactNode;
  count: number;
  gap: number;
};

const CityStateZipcode = ({
  cityName,
  stateName,
  zipcodeName,
  componentBefore,
  count,
  gap,
}: Props) => {
  const zipcode = useWatch({ name: zipcodeName || "zipcode" });
  const currentState = useWatch({ name: stateName || "state" });
  const usStateNames = useMemo(
    () => Object.keys(USDATA).sort((a, b) => a.localeCompare(b)),
    [],
  );
  const stateSelectOptions = useMemo(() => {
    if (typeof currentState === "string" && currentState.trim() && !usStateNames.includes(currentState)) {
      return [currentState.trim(), ...usStateNames];
    }
    return usStateNames;
  }, [usStateNames, currentState]);
  const [zipcodeLoad, setZipcodeLoad] = useState<any>(false);
  const [zipcodeErr, setZipcodeErr] = useState<any>(false);
  const { setValue } = useFormContext();

  async function getMapsDetails() {
    if (zipcode?.length < 5 || zipcode?.length > 5) {
      setZipcodeErr("Invalid Zipcode");
      return;
    }
    try {
      setZipcodeLoad(true);
      const { data }: any = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&key=${import.meta.env.VITE_LOCATION_KEY}`,
      );
      if (data?.status == "ZERO_RESULTS") {
        setZipcodeErr("Zipcode not found");
        return;
      }
      let city = data?.results?.[0]?.address_components?.[1]?.long_name;
      let state = data?.results?.[0]?.address_components?.[3]?.long_name;
      console.log({ city, state });
      // Only overwrite form values when API returned valid values; otherwise we'd overwrite
      // existing patient state/city with undefined and break validation on Update Patient
      // if (city != null && city !== "") {
      //   setValue(cityName || "city", city);
      // }
      // if (state != null && state !== "") {
      //   setValue(stateName || "state", state);
      // }
      setZipcodeErr(null);
      // console.log(data?.results?.[0]?.address_components?.[1]?.long_name);
    } catch (e: any) {
      console.log(e?.message);
      setZipcodeErr(e?.message);
    } finally {
      setZipcodeLoad(false);
    }
  }

  // const citySelectOptions = useMemo(() => {
  //   return USDATA[currentState as keyof typeof USDATA] || [];
  // }, [currentState]);

  useEffect(() => {
    if (zipcode && zipcode.length == 5) {
      getMapsDetails();
    }
    setZipcodeErr(null);
  }, [zipcode]);
  return (
    <Grid count={count} gap={gap}>
      {componentBefore ? componentBefore : null}

      

      <RhfInput name={cityName || "city"} label="City" required />

      <RhfSelect
        name={stateName || "state"}
        label="State"
        required
        options={stateSelectOptions}
        placeholder="Select state"
      />
      
      {/* <RhfSelect
        name={cityName || "city"}
        label="City"
        required
        options={citySelectOptions}
        placeholder="Select city"
      /> */}

    
      <div>
        <div className="relative">
          <RhfInput
            name={zipcodeName || "zipcode"}
            label="Zipcode"
            isNumber
            // maxLength={5}
            required
          />
          {/* <Button type="button" disabled={zipcodeLoad} onClick={getMapsDetails} className="absolute bottom-0.5 right-0" variant={'outline'}  size={'sm'}>

       {zipcodeLoad ? <Circle size={'16'}/> : <Search  size={'16'}/>}
        </Button> */}
        </div>
        {zipcodeErr && (
          <p className="text-xs text-red-500 mt-0.5">ERROR : {zipcodeErr} </p>
        )}
      </div>
    </Grid>
  );
};

export default CityStateZipcode;
